import React from "react"
import Skeleton from "react-loading-skeleton"

function NewsDetailSkeleton() {
  return (
    <article className="uk-article uk-container uk-margin-large-bottom">
      <h1 className="uk-article-title">
        <Skeleton width={500} />
      </h1>
      <Skeleton width={300} height={300} />

      <p className="uk-article-meta">
        <Skeleton width={300} />
      </p>

      <p>
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </p>
    </article>
  )
}

export default NewsDetailSkeleton
